import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

interface ConversionBlockProps {
  className?: string;
}

const ConversionBlock = ({ className = "" }: ConversionBlockProps) => {
  return (
    <section className={`px-4 py-12 md:py-16 ${className}`}>
      <div className="max-w-3xl mx-auto text-center bg-card/40 border border-border/50 rounded-2xl p-8 md:p-10">
        <h2 className="text-2xl md:text-3xl font-semibold mb-3">
          Convert your file to editable format
        </h2>
        <p className="text-muted-foreground mb-6 max-w-xl mx-auto">
          Turn scanned PDFs and images into fully editable Word or Excel files in seconds.
        </p>
        <Link to="/scan">
          <Button size="lg" className="text-base md:text-lg px-8 py-6">
            <Upload className="mr-2 h-5 w-5" />
            Upload &amp; Convert
          </Button>
        </Link>
        <p className="text-xs md:text-sm text-muted-foreground mt-3">
          Free preview available — download requires upgrade
        </p>
      </div>
    </section>
  );
};

export default ConversionBlock;